import { call } from 'redux-saga/effects';
import { oc } from 'ts-optchain';
import {
  EnvironmentRequest,
  EnvironmentRequestProduct,
  EnvironmentState,
  ProductNode
} from 'vrlcm-gui-types';
import { toSafeSelectedProducts, toSafeUIData } from 'vrlcm-gui-utils';
import EnvironmentsAPI from '../../api/Environments';
import EnvironmentWorkflowAPI from '../../api/workflows/EnvironmentWorkflow';
import { getVropsCaDataNodes, getVropsCaDefaultNodes } from '../../mocks/specs';
import { Day2Operation } from '../../types/Environments';
import { EnvironmentApi } from 'vrlcm-gui-api';
import { deepClone, generateUniqueId } from 'components/lcops/utils/Helpers';
export function* updateParentEnvironment(
  uiDataStr: string,
  op: Day2Operation,
  productId?: string
) {
  const uiData = toSafeUIData(uiDataStr);
  const parentId = oc(uiData.trackingRequests).parent();
  const environments: EnvironmentState[] = yield call(
    EnvironmentsAPI.getEnvironments
  );
  const parent = environments.find(e => e.requestId === parentId);
  if (parent) {
    const parentUIData = toSafeUIData(parent.uiData);
    if (parentUIData.trackingRequests) {
      const requestKey = op === 'organic-growth' ? op : `${op}:${productId}`;
      delete parentUIData.trackingRequests[requestKey];
    }
    parent.uiData = JSON.stringify(parentUIData);
    yield call(EnvironmentWorkflowAPI.patchCreateEnvironmentDetails, parent);
  }
}

export function* resyncOrganicGrowthRequest(state: EnvironmentState) {
  const environment: EnvironmentRequest = yield call(
    EnvironmentApi.getEnvironmentRequestById,
    state.environmentRequestDTO.environmentId
  );
  const environmentProducts = environment.products;
  let selectedProducts = toSafeSelectedProducts(state.environmentRequestDTO);
  selectedProducts = selectedProducts.filter(
    p =>
      !p.disabled ||
      (p.disabled && environmentProducts.findIndex(ep => ep.id === p.id) !== -1)
  );
  selectedProducts = selectedProducts.map(p => {
    const envProduct = environmentProducts.filter(ep => ep.id === p.id);
    if (envProduct && envProduct.length > 0) {
      p.selectedVersion = envProduct[0].version;
    }
    return p;
  });

  state.environmentRequestDTO.infrastructure.properties._selectedProducts = JSON.stringify(
    selectedProducts
  );
}

export const getVropsCaNodes = (
  vrops: EnvironmentRequestProduct,
  dataNodePairCount: number
) => {
  const [masterNode, replicaNode, witnessNode] = getVropsCaDefaultNodes(vrops);

  let dataNodes = vrops.nodes.filter(n => n.type === 'data');
  if (dataNodes.length === 0) {
    dataNodes = getVropsCaDataNodes(dataNodePairCount);
  }

  const remoteCollectorNodes = vrops.nodes.filter(
    n => n.type === 'remotecollector'
  );

  let cloudProxyNodes = vrops.nodes.filter(n => n.type === 'cloudproxy');
  //assigining __group and __pairId as these are not getting persisted in some cases
  cloudProxyNodes = deepClone(cloudProxyNodes).map(
    (cloudProxy: ProductNode) => {
      cloudProxy.properties.__group = 'cloudproxy';
      if (!cloudProxy.properties.__pairId)
        cloudProxy.properties.__pairId = generateUniqueId();
      return cloudProxy;
    }
  );

  const vropsCaNodes = [
    masterNode,
    replicaNode,
    witnessNode,
    ...dataNodes,
    ...remoteCollectorNodes,
    ...cloudProxyNodes
  ];
  return vropsCaNodes;
};
